import CloseIcon from '@mui/icons-material/Close';
import UndoIcon from '@mui/icons-material/Undo';
import {Alert, AlertTitle, CircularProgress, Fab, IconButton, Typography} from '@mui/material';
import React, {useContext, useEffect, useRef, useState} from 'react';

import {QuobisServiceContext, RouterContext} from '../providers/Context.providers';

import styles from './Calling.module.scss';
import {RouteNames} from './RouterContainer';

export default function Calling(): JSX.Element {
	const [error, setError] = useState('');
	const quobisService = useContext(QuobisServiceContext);
	const router = useContext(RouterContext);
	const calling = useRef(false);

	const back = async (): Promise<void> => {
		router?.setRoute(RouteNames.DIALPAD);
	};

	// @ts-ignore
	useEffect(() => {
		const call = async (): Promise<void> => {
			try {
				calling.current = true;
				const callResult = await quobisService?.call();
				/* eslint-disable no-console */
				console.log('callResult', callResult);
				if (callResult === true) {
					router?.setRoute(RouteNames.CALL);
				} else {
					await back();
				}
			} catch (_error: unknown) {
				if (_error instanceof Error) {
					setError(_error.message);
				}
			}
		};

		if (calling.current) {
			return;
		}
		call().catch((e) => {
			throw e;
		});
	}, [quobisService, calling, router]);
	const cancel = async (): Promise<void> => {
		await quobisService?.leave();
		await back();
	};

	return (
		<div className={styles.calling}>
			{
				error ?
					<div>
						<Alert severity="error"
							action={
								<IconButton
									aria-label="close"
									color="inherit"
									size="small"
									onClick={back}
								>
									<CloseIcon fontSize="inherit" />
								</IconButton>
							}
						>
							<AlertTitle>The call could not be created</AlertTitle>
							{error}
							<Fab
								aria-label="back"
								color="error"
								size="small"
								onClick={async () => {
									await back();
								}}
								className={styles.backButton}
							>
								<UndoIcon fontSize="medium" />
							</Fab>
						</Alert>
					</div>
					:
					<div>
						<CircularProgress />
						<Typography variant="h5" margin={4}>Calling...</Typography>
						<Fab
							aria-label="back"
							color="error"
							size="small"
							onClick={async () => {
								await cancel();
							}}
							className={styles.backButton}
						>
							<UndoIcon fontSize="medium" />
						</Fab>
					</div>
			}
		</div>
	);
}
